import * as React from 'react';
// eslint-disable-next-line no-unused-vars
import LeftNavItem from '../LeftNavItem/LeftNavItem';
import { SiteNavLink } from '../LeftNavItem/SiteNavLink';

/* eslint-disable no-unused-vars */
export enum NavLevelModifier {
  Primary,
  Secondary,
  Tertiary
}
/* eslint-enable no-unused-vars */

export interface LeftNavProps {
  links: SiteNavLink[];
  navLevelModifier?: NavLevelModifier;
  isExpanded?: boolean;
}

const PRIMARY_MODIFIER = 'site-nav__nav-container--primary';
const SECONDARY_MODIFIER = 'site-nav__nav-container--child site-nav__nav-container--secondary';
const TERTIARY_MODIFIER = 'site-nav__nav-container--child site-nav__nav-container--tertiary';

const EXPANDED_NAV_STYLES = { display: 'block', height: 'inherit' };

const LeftNav = ({
  links,
  navLevelModifier = NavLevelModifier.Primary,
  isExpanded = true,
}: LeftNavProps): JSX.Element => {
  const modifier = navLevelModifier === NavLevelModifier.Primary
    ? PRIMARY_MODIFIER
    : navLevelModifier === NavLevelModifier.Secondary
      ? SECONDARY_MODIFIER
      : TERTIARY_MODIFIER;

  // Get the Initial Expanded Group
  const getInitialExpandedGroup = (): string => {
    let group: string = null;

    links.forEach((navItem: SiteNavLink) => {
      const active = navItem.subLinks ? navItem.subLinks.filter((x: SiteNavLink) => x.isActive === true).length > 0 : false;

      if (active) {
        group = navItem.displayText;
      }
    });

    return group;
  };

  // Current Expanded Group
  const [expandedGroup, setExpandedGroup] = React.useState(getInitialExpandedGroup());

  // Set the Current Expanded Group
  const onExpandGroup = (group: string) => setExpandedGroup(group);

  return (
    <nav className={`site-nav__nav-container ${modifier}`} style={isExpanded ? EXPANDED_NAV_STYLES : {}}>
      <ol className="u-list-unstyled site-nav__list">
        {/* eslint-disable-next-line max-len */}
        {links.map((link) => <LeftNavItem key={link.value} navItem={link} parentLevelModifier={navLevelModifier} expandedGroup={expandedGroup} onExpandGroup={onExpandGroup} />)}
      </ol>
    </nav>
  );
};

export default LeftNav;
